import React from 'react';
import DetailModal from '../../../../../../Components/DetailModal';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { GetSingleAppNotification } from '../../../../../../Api/appnotifications';
import { ErrorToast } from "../../../../../../Utils/SweetAlert"
import { useNavigate } from 'react-router-dom';

const ViewAppNotifications = ({ onClose, details }) => {
  const stateData = useLocation();
  const navigate = useNavigate();

  const { id } = stateData?.state || "";

  const { data, error } = useQuery({
    queryKey: ["get-single-app-notifications", id],
    queryFn: () => GetSingleAppNotification({ id }),
    onError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");

    },
  });


  const notificationDetails = data || details;

  return (
    <DetailModal className='appnotification-modal' centered show size='lg' onClose={onClose} title='Details'>
      <div className='detail-list'>
        <div className='detail-item'>
          <div className='detail-content'>
            <div className='modal-label'>Title</div>
            <div className='modal-value content-text'>{notificationDetails?.title || '-'}</div>
          </div>
        </div>

        <div className='detail-item'>
          <div className='detail-content'>
            <div className='modal-label'>Message</div>
            <div className='modal-value content-text'>{notificationDetails?.message || '-'}</div>
          </div>
        </div>

        <div className='detail-item'>
          <div className='detail-content'>
            <div className='modal-label'>Day</div>
            <div className='modal-value content-text'>
              {notificationDetails?.day || '-'}
            </div>
          </div>
        </div>
      </div>
    </DetailModal>
  );
};

export default ViewAppNotifications;
